import { render, staticRenderFns } from "./edit-warehouse.vue?vue&type=template&id=5c6a6e35&"
import script from "./edit-warehouse.vue?vue&type=script&lang=ts&"
export * from "./edit-warehouse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports